import Module from '../../modules/Module';

export default class Admin extends Module {
  static Info = {
      "nameResource": "admin",
      "icon": "fas fa-user-shield admin-menus-color",
      "path": "",
      "show": true
  };
}